<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AT2OS6/tc-custom/9781488096501.jpg?1708746634874" alt="This image is the cover for the book What Doesn't Kill Her, Cape Charade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Doesn't Kill Her, Cape Charade
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i>–Bestselling Author: “Action-packed, littered with dead bodies, and brimming with heartfelt emotion, this edgy thriller keeps the tension high.” —<i>Library Journal</i> (starred review)</b><br/><br/><i>One secret, one nightmare, one lie. You guess which is which.</i><br/><br/><i>1. I have the scar of a gunshot on my forehead.</i><br/><br/><i>2. I have willfully misrepresented my identity to the US military.</i><br/><br/><i>3. I’m the new mother of a seven-year-old girl. </i><br/><br/>Kellen Adams suffers from a year-long gap in her memory. A bullet to the brain will do that. But she’s discovering the truth, and what she learns changes her life, her confidence, her very self. She finds herself in the wilderness, on the run, unprepared, her enemies unknown—and she is carrying a priceless burden she must protect at all costs. The consequences of failure would break her. And Kellen Adams does not break. What doesn’t kill her . . . had better start running.<br/><br/>“An unforgettable protagonist . . . who makes Jack Reacher look like a slacker . . . and an ingenious plot that includes plenty of white-knuckle twists and turns.” —<i>Booklist</i> (starred review)<br/><br/>“Sign me up for anything Christina Dodd writes.” —Karen Robards, <i>New York Times</i>–bestselling author of <i>The Girl from Guernica</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christina Dodd
      </h2>
      
      <p class="authorDescription body article">New York Times bestselling author Christina Dodd writes “edge-of-the-seat suspense” (Iris Johansen) with “brilliantly etched characters, polished writing, and unexpected flashes of sharp humor that are pure Dodd” (ALA Booklist). Her fifty-eight books have been called "scary, sexy, and smartly written" by Booklist and, much to her mother's delight, Dodd was once a clue in the Los Angeles Times crossword puzzle. Enter Christina’s worlds and join her mailing list at www.christinadodd.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c860466